module.exports = __webpack_public_path__ + "img/pick3.e5c9ab43.webp";